import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { VentaDiaria } from '../../inicio.service';
import { DiaSemana } from '../../shared/types';
import { colorBarra, customizeTooltip, formatShort } from '../../shared/format';
import { exportarElemento } from '../../shared/export';
import { calcularDiasSemana } from '../../shared/metrics';

@Component({
  selector: 'app-comparativa-dias',
  templateUrl: './comparativa-dias.component.html',
  styleUrls: ['./comparativa-dias.component.scss']
})
export class ComparativaDiasComponent implements OnChanges {
  @Input() ventasDiarias: VentaDiaria[] = [];
  @Input() ventasAnterior: VentaDiaria[] = [];
  @ViewChild('exportRef') exportRef!: ElementRef;

  diasSemana: DiaSemana[] = [];

  formatShort = formatShort;
  customizeTooltip = customizeTooltip;

  ngOnChanges() {
    this.diasSemana = calcularDiasSemana(this.ventasDiarias, this.ventasAnterior);
  }

  exportar(tipo: 'png' | 'pdf') {
    exportarElemento(this.exportRef.nativeElement, tipo, 'comparativa-dias', ['.export-actions']);
  }

  customizePromPoint = (arg: any): any => {
    const item = this.diasSemana.find((d: { nombre: string }) => d.nombre === arg.argument);
    const esKg = arg.seriesName === 'Kg';
    const positivo = (esKg ? item?.colorKg : item?.color) !== '#f87171';
    return { color: colorBarra(positivo, esKg) };
  };
}
